export const color = {
  mainBlue: "#636FD7",
  mainGreen: "#57D4D4",
  tableHeader: "#60C9C9",
  textWhite: "#FFFFFF",
};
